import { Component, Inject, forwardRef } from '@angular/core';
import { ViewController, AlertController } from 'ionic-angular';
import { EbsComponentService } from "../../services/ebsComponentService";

@Component({
  selector: 'tablepopovermore',
  templateUrl: 'tablepopover-more.html'
})

export class TablePopoverMore {

  ListItemAction: any;
  navCtrl: any;
  collapsedStatus: any;

  constructor(
    public viewCtrl: ViewController,
    @Inject(forwardRef(() => EbsComponentService)) private _ebsComponentService: EbsComponentService,
    private alertCtrl: AlertController) {
    this.ListItemAction = viewCtrl.data.ListItemAction;
    this.navCtrl = viewCtrl.data.navCtrl;
    this.collapsedStatus = viewCtrl.data.collapsedStatus;
  }

  handleAction(element) {
    if (element.ActionName == 'Delete') {
      this.delete(element);
    } else {
      this.defaultAction(element);
    }
  }

  defaultAction(element) {
    let navParams = {
      title: null,
      actionURL: element.ActionUrl,
      postParams: element.PostParameters
    };
    this._ebsComponentService.navigationController(element, navParams, this.navCtrl);
    this.viewCtrl.dismiss();
  }

  delete(element) {
    let alert = this.alertCtrl.create({
      title: 'Löschen',
      message: 'Wollen sie den Eintrag löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            console.log('Alert got canceled');
          }
        },
        {
          text: 'Bestätigen',
          handler: () => {
            console.log('Confirmed');

            let navParams = {
              title: 'Delete',
              actionURL: element.ActionUrl,
              postParams: element.PostParameters,
              collapsedStatus: this.collapsedStatus
            };
            this._ebsComponentService.navigationController(element, navParams, this.navCtrl);
            this.viewCtrl.dismiss();

          }
        }
      ]
    });
    alert.present();
  }
}


// WEBPACK FOOTER //
// ./src/popovers/tablepopover-more/tablepopover-more.ts